module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-jsx/style.js
// module id = 33
// module chunks = 0